import Ep from './components/Ep'
import Register from './components/Register'

import apConfig from "@config/347.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {Ep,Register}

export const portals = {}

